import api from "api";

// Consultoria grátis com a equipe da Whizr (contrato em
// ENG_API_Core-v1/docs/2026-10-16-consulting-scheduling.md).
const consultations = {
    // `eligibility` (se pode marcar e, se não, por quê), `booking` (a consulta
    // marcada que ainda não terminou, ou null) e `topics` (assuntos para escolher).
    status: () => {
        return api().get('/producer-profiles/me/consultations');
    },

    // Consultores com horário livre e, de cada um, os dias e horários.
    slots: () => {
        return api().get('/producer-profiles/me/consultations/slots');
    },

    // { consultant_id, starts_at, topic?, notes? }. `starts_at` é um dos horários de `slots`.
    book: (payload) => {
        return api().post('/producer-profiles/me/consultations', payload);
    },

    cancel: (id) => {
        return api().post(`/producer-profiles/me/consultations/${id}/cancel`);
    },
};

export default consultations;
